// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dejC","fullView":"styles_fullView__9jvb2"};